import moment from "moment";
import React, { useMemo } from "react";
import { ScheduleData } from "src/api/reservation/reservation-type";
import { formatEndTime, numberToStringWithComma, ViewYmdFormat } from "src/utils/common-util";

type Props = {
  selectedSchedule: ScheduleData[];
};
const ReservationTimeAndPrice = ({ selectedSchedule }: Props) => {
  const price = useMemo(() => selectedSchedule.reduce((accumulator, time) => accumulator + time.price!, 0), [selectedSchedule]);
  const seletedTime = useMemo(
    () =>
      selectedSchedule.map((item) => {
        return { startDate: item.startDate, endDate: item.endDate };
      }),
    [selectedSchedule],
  );

  // 종료시각이 자정인 slot 은 날짜가 다음날로 넘어가므로 날짜/요일은 시작시각 기준으로 표기 (QA-3824)
  const startTime = useMemo(() => moment.min(seletedTime.map((time) => moment(time.startDate))), [seletedTime]);
  const day = useMemo(() => startTime.format("ddd"), [startTime]);
  const start = useMemo(() => startTime.format(ViewYmdFormat.HH_MM), [startTime]);
  const end = useMemo(() => formatEndTime(moment.max(seletedTime.map((time) => moment(time.endDate)))), [seletedTime]);
  const date = useMemo(() => startTime.format(ViewYmdFormat.YYYY_MM_DD), [startTime]);

  return (
    <div className="text-center font16 font-weight-400 mb10">
      <span className="">{`${numberToStringWithComma(price)}원`}</span>
      <span className="font15 font-weight-100 ml5">(부가세 별도)</span>
      <span className="mx5">|</span>
      <span>{`${date}(${day})`}</span>
      <span className="ml5">{start}</span>
      {end && <span> ~ {end}</span>}
    </div>
  );
};

export default ReservationTimeAndPrice;
